/* AJ 2026-10-12 18:00: every under-sink system opens with the chrome faucet (European handle) chosen, as the Thunder RO
   line already does. The faucet choice comes from the options app (SC Product Options), which draws its groups after the
   page loads, so this waits for the "Faucets Style" group and, only when nothing in it is chosen yet, clicks the chrome
   European handle swatch so the app updates its own price and cart line. A shopper's later choice is never overridden.
   Loaded by sections/main-product.liquid on products whose title says "Under Sink". */
(() => {
  const WANT = /^Chrome Faucet with 1\/4" Tube \(European Handle\)$/;
  let tries = 0;
  const run = () => {
    const groups = [...document.querySelectorAll('.bold_option')]
      .filter((group) => /faucet/i.test(group.querySelector('.bold_option_title')?.textContent || ''));
    const inputs = groups.flatMap((group) => [...group.querySelectorAll('input[type="radio"], input[type="checkbox"]')]);
    if (!inputs.length) {
      if (++tries < 48) setTimeout(run, 250);
      return;
    }
    groups.forEach((group) => {
      const choices = [...group.querySelectorAll('input[type="radio"], input[type="checkbox"]')];
      if (!choices.length || choices.some((input) => input.checked)) return;
      const chrome = choices.find((input) => WANT.test((input.value || '').trim()));
      if (chrome && !chrome.disabled) chrome.click();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
